import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-live.svg";

type LiveProps = React.SVGProps<SVGSVGElement>;

export const Live = (props: LiveProps) => <Svg {...props} />;
